export const formatDateTime = (dateString) => {
  const date = new Date(dateString);

  const day = date.toLocaleDateString("it-IT", {
    day: "2-digit",
  });

  const month = date.toLocaleDateString("it-IT", {
    month: "numeric",
  });

  const year = date.toLocaleDateString("it-IT", {
    year: "numeric",
  });

  const time = date.toLocaleTimeString("it-IT", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return `${day}/${month}/${year}`;
};
